import { useSelector } from 'react-redux'
import { selectAllSalesTeams } from '@user/store/salesTeam/slice'
import { ImportUtilityModel } from '../typings'
import { useEffect, useMemo } from 'react'
import { useAppDispatch } from '@sales-center/common'
import { getSalesTeamUsers } from '@user/store/salesTeam'
import {
  selectAllSalesFunnels,
  selectAllSalesFunnelStages,
} from '@user/store/salesFunnel'
import { ENTITY_TYPES } from '@sales-center/common'
import { useGetBranchServiceProducts } from '@user/store/serviceProducts'
import { selectAllServiceFrequencies } from '@user/store/serviceFrequency'
import { ImportEntityType } from '../../typings'

export function useFieldOptionsData(formData: ImportUtilityModel) {
  const dispatch = useAppDispatch()
  const { getServices } = useGetBranchServiceProducts()

  const allSalesTeams = useSelector(selectAllSalesTeams)

  const serviceFrequencies = useSelector(selectAllServiceFrequencies)

  useEffect(() => {
    if (formData.entityType != ImportEntityType.DraftLead) {
      dispatch(
        getSalesTeamUsers(
          formData.salesTeamId ? parseInt(formData.salesTeamId) : -1,
        ),
      )
    }
  }, [formData.salesTeamId, formData.entityType, dispatch])

  useEffect(() => {
    if (formData.salesTeamId) {
      const branchId = allSalesTeams?.find(
        (row) => row?.id?.toString() == formData.salesTeamId?.toString(),
      )?.branchId
      getServices(branchId ? branchId?.toString() : '-1')
    }
  }, [formData.salesTeamId, getServices, allSalesTeams])

  const unSortedSalesFunnels = useSelector(selectAllSalesFunnels)

  const salesFunnels = useMemo(() => {
    return unSortedSalesFunnels.sort((a, b) => {
      if (a.isDefault) return -1
      else if (b.isDefault) return 1
      return a.name.localeCompare(b.name)
    })
  }, [unSortedSalesFunnels])

  const entityType = useMemo(() => {
    if (formData.entityType == ImportEntityType.Opportunity) {
      return ENTITY_TYPES.Opportunity
    }
    return ENTITY_TYPES.Lead
  }, [formData.entityType])

  const stages = useSelector(selectAllSalesFunnelStages)
  const salesFunnelStages = useMemo(() => {
    if (formData.salesFunnelId) {
      const salesFunnelId = parseInt(formData.salesFunnelId)
      return stages.filter(
        (x) =>
          x.sectionType.toLowerCase() === entityType.toLowerCase() &&
          x.closed === false &&
          (salesFunnelId === -1 || x.salesFunnelId == salesFunnelId),
      )
    }
    return []
  }, [formData.salesFunnelId, entityType, stages])

  return {
    allSalesTeams,
    salesFunnels,
    salesFunnelStages,
    serviceFrequencies,
  }
}
